import React from 'react'

const cardListItem = (props) => {
    return <div className="list-item">{props.text}</div>
}

export default cardListItem
